var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ActivityReportingInformation" },
    [
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.collapseNumber,
            callback: function ($$v) {
              _vm.collapseNumber = $$v
            },
            expression: "collapseNumber",
          },
        },
        [
          _c(
            "el-collapse-item",
            {
              staticClass: "collapseItem",
              attrs: { title: "活动提报信息", name: "default" },
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "form UniformCss",
                  attrs: { "label-width": "100px", "label-position": "right" },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "formItem",
                              attrs: { label: "经理部" },
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.data.regionName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "regionName", $$v)
                                  },
                                  expression: "data.regionName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false",
                            },
                          ],
                          attrs: { span: 6 },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "formItem",
                              attrs: { label: "经销商" },
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.data.dealerName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "dealerName", $$v)
                                  },
                                  expression: "data.dealerName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "formItem",
                              attrs: { label: "经销商" },
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.data.dealerShortName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "dealerShortName", $$v)
                                  },
                                  expression: "data.dealerShortName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "act-item",
                              attrs: { label: "计划开始日期" },
                            },
                            [
                              _c("a-date-picker", {
                                attrs: { type: "date", disabled: "" },
                                model: {
                                  value: _vm.data.planStartTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "planStartTime", $$v)
                                  },
                                  expression: "data.planStartTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "act-item",
                              attrs: { label: "计划结束日期" },
                            },
                            [
                              _c("a-date-picker", {
                                attrs: { type: "date", disabled: "" },
                                model: {
                                  value: _vm.data.planEndTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "planEndTime", $$v)
                                  },
                                  expression: "data.planEndTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(_vm.getFormByActivity(_vm.activity.threeLevelName), {
                    ref: "activityForm",
                    tag: "component",
                    attrs: {
                      formData: _vm.data,
                      formType: "detail",
                      priceDiff: _vm.priceDiff,
                    },
                  }),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { height: "auto" },
                          attrs: { span: 18 },
                        },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "pp", attrs: { label: "计划方案" } },
                            [
                              _c("el-upload", {
                                ref: "uploadFile",
                                staticClass: "upload-demo",
                                attrs: {
                                  action: "",
                                  "on-preview": _vm.onPreviewFun,
                                  "auto-upload": false,
                                  "file-list": _vm.fileList,
                                  disabled: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }